<template>
  <div class="md-layout-item md-size-25 md-small-size-100">
    <div class="md-card bg-transparent border-0">
      <div class="md-card-header md-card-header-icon md-card-header-white">
        <div class="card-icon bg-white">
          <span><img class="img cooking" :src="img" style="width: 24px; height: 24px;" /></span>
        </div>
        <h4 class="title">{{ title }}</h4>
      </div>
      <div class="md-card-content p-0">
        <div class="md-layout" v-if="orders.length > 0">
          <div
            class="p-1 md-layout-item md-size-100"
            v-for="order in orders"
            :key="order._id"
          >
            <order-card
              @change="changeOrderStatus"
              :data="order"
              :currency="currency"
              class="card-order"
            ></order-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OrderCard } from "@/components";

// Mock function to replace non-existent import
const getAllAction = async () => {
  console.warn(
    "getAllAction is not available - Orders actions module was removed"
  );
  return { success: false, data: [] };
};

export default {
  name: "OrderList",
  components: {
    OrderCard,
  },
  props: {
    title: {
      type: String,
      default: () => {
        return "";
      },
    },
    img: {
      type: String,
      default: () => {
        return "";
      },
    },
    color: {
      type: String,
      default: () => {
        return "";
      },
    },
    orders: {
      default: () => {
        return [];
      },
    },
    currency: {
      type: String,
      default: "$",
    },
  },
  methods: {
    changeOrderStatus(order, status) {
      this.$emit("change", order, status);
    },
  },
};
</script>

<style scoped>
.table-transparent {
  background-color: transparent !important;
}

.mt-0 {
  margin-top: 0 !important;
}
</style>
